module.exports = __webpack_public_path__ + "static/media/tour-4.d82eaa9f.jpg";